<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">
            
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mt-2">
                    <div class="col-6">
                        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateServiceGroupmodal" (click)="clearServiceGroup()" 
                            *ngIf="fp.servicegroupcreate">Add
                            Service Group</button>
                    </div>
                    <div class="col-6 ">
                        <button type="button" class="btn btn-sm text-right " (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
                <div class="row mt-3" style="min-height: 500px;">
                    <div class="col">
                        <ejs-grid #gridServiceGroup [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
                        [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                        (dataStateChange)='dataChangeServiceGroup($event)' [showColumnChooser]='true'
                        (actionBegin)="onActionServiceGroup($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal"
                                        data-bs-target="#CreateServiceGroupmodal" (click)="getDetails(data)"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" (click)="getDeleteId(data.id)"  data-bs-toggle="modal"
                                    data-bs-target="#deleteSGModal"><i
                                            class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="serviceGroupName" headerText="Service Group Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                          
    
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showServiceGroupColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- For Create or Update Modal -->
<span id="openServiceGroupModal" data-bs-toggle="modal" data-bs-target="#CreateServiceGroupmodal"></span>
<div class="modal fade" id="CreateServiceGroupmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveServiceGroupInfo.id == '00000000-0000-0000-0000-000000000000'">
                        Create Service Group</span>
                    <span *ngIf="saveServiceGroupInfo.id !='00000000-0000-0000-0000-000000000000'">Update Service Group</span>
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="clearServiceGroup()"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Service GroupName<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceGroupInfo.serviceGroupName" />
                    </div>
                </div>
                
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateServiceGroup();" [disabled]="isSaveorUpdateBoolean || saveServiceGroupInfo.serviceGroupName==null ||
                saveServiceGroupInfo.serviceGroupName==undefined || saveServiceGroupInfo.serviceGroupName==''"><span
                        *ngIf="saveServiceGroupInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span *ngIf="saveServiceGroupInfo.id != '00000000-0000-0000-0000-000000000000'">Update &
                        Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal" (click)="clearServiceGroup()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeSGModal" data-bs-target="#deleteSGModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteSGModal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteServiceGroup()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearServiceGroup()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>